import { Link } from 'gatsby';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';
import { event } from '../../../lib/gtag';
import Button from '../../atoms/button';
import MagnifyingGlass from '../../atoms/magnifying-glass';

interface Props {
  openSearch: boolean;
  setOpenSearch: React.Dispatch<React.SetStateAction<boolean>>;
  className?: string;
  close?: () => void;
}

const GlobalNavigation: React.FC<Props> = ({
  openSearch,
  setOpenSearch,
  className,
  close,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`font-bold lg:flex ${className}`}>
      <div className='px-8 lg:flex lg:px-0'>
        <p className='mt-2 py-2 font-roboto font-medium text-lsGray-400 lg:hidden'>
          {t('header.getting_started')}
        </p>
        <ul className='mb-6 flex flex-col lg:m-0 lg:flex-row lg:items-center lg:text-sm'>
          <li>
            <Link to='/docs/service' onClick={() => close && close()}>
              {t('header.service')}
            </Link>
          </li>
          <li>
            <Link to='/docs/guide' onClick={() => close && close()}>
              {t('header.guide')}
            </Link>
          </li>
          <li>
            <Link to='/docs/price' onClick={() => close && close()}>
              {t('header.price')}
            </Link>
          </li>
        </ul>
        <p className='mt-2 py-2 font-roboto font-medium text-lsGray-400 lg:hidden'>
          {t('header.developer')}
        </p>
        <ul className='mb-6 flex flex-col lg:m-0 lg:flex-row lg:items-center lg:text-sm'>
          <li>
            <Link
              to='/docs/application-developer-guide'
              onClick={() => close && close()}
            >
              {t('header.development')}
            </Link>
          </li>
          <li>
            <Link
              to='/docs/sdk-support-period'
              onClick={() => close && close()}
            >
              {t('header.support')}
            </Link>
          </li>
          <li>
            <Link
              to='/docs/error-without-h264codec'
              onClick={() => close && close()}
            >
              {t('header.faq')}
            </Link>
          </li>
        </ul>
      </div>
      <div className='flex justify-between px-4 py-16 lg:p-0'>
        <Button
          className='mr-6 w-full text-xs lg:mr-4 lg:w-auto lg:px-6'
          label={t('header.signup')}
          onClick={() => {
            event('click_free_trial', { location: 'header' });
            open(
              'https://console.livestreaming.mw.smart-integration.ricoh.com/login/register',
              '_blank',
              'noopener noreferrer',
            );
          }}
        />
        <Button
          className='w-full text-xs lg:w-auto lg:px-6'
          label={t('header.login')}
          onClick={() => {
            open(
              'https://console.livestreaming.mw.smart-integration.ricoh.com/',
              '_blank',
              'noopener noreferrer',
            );
          }}
        />
      </div>
      <MagnifyingGlass
        className='hidden lg:ml-6 lg:block'
        onClick={() => {
          event('click_search');
          setOpenSearch(!openSearch);
        }}
      />
    </div>
  );
};

GlobalNavigation.displayName = 'GlobalNavigation';

export default GlobalNavigation;
